import type { User } from "features/user";
import { hasEntitlement } from "utils/has-entitlement";

/**
 * Gate for the GA4 property assignment UI in Group Settings.
 *
 * This is the main-app twin of Insights' `permissionService.hasGa4InsightsPermission()`
 * (which reads the Insights store's user). The account-groups form lives in the
 * MAIN app with a different user shape, so the gate is reimplemented here against
 * `User.preferences.entitlements`.
 *
 * Reads the `ga4-insights` entitlement so the gate follows Chargebee like the
 * rest of the app. Keep this in lockstep with the Insights-side gate — the two
 * must always agree on who can see GA4 surfaces.
 */
export function hasGa4SettingsAccess(user: User | null | undefined): boolean {
  return hasEntitlement(user, "ga4-insights");
}
